languages:
    en: { code: "EN", name: "Anglais" }
    fr: { code: "FR", name: "Français" }

gender:
    male: "Homme"
    female: "Femme"
    unknown: "Inconnu"
